<div class="feedback-wrapper container-fluid py-5">
    <div class="feedback-inside container-fluid bg-white mt-1 pt-4 px-4 px-sm-5"
        style="background-color: white;">
        <div class="d-flex justify-content-center pt-3" id="feedback-modal" #feedbackContainer></div>
        <div *ngIf="submittedForm" class="feedback-hubspot-hide-success"></div>
        <div *ngIf="submittedForm" class="success-message">
            {{ 'APP.MAIN.NAVBAR.SUCCESS_MESSAGE' | translate }}
        </div>
    </div>
</div>